import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from 'src/store/reduxTypes';

interface UseCompanyClientsFilterHook {
  searchKey: string;
}

/**
 * Searches companies by name and return all client ids for matched companies
 * @param options
 * @returns
 */
export const useCompanyClientsFilter = (
  options: UseCompanyClientsFilterHook,
) => {
  const { clients, companies, isClient } = useSelector(
    (state: RootState) => ({
      clients: state.clients.assignedClients,
      companies: state.clients.activeCompanies,
      isClient: state.user.isClient,
    }),
    shallowEqual,
  );

  const companyClientIds = React.useMemo(() => {
    if (isClient) {
      return [];
    }

    const filteredCompanyIds = companies
      .filter(company =>
        company.fields.name
          .toLowerCase()
          .includes(options.searchKey.toLowerCase()),
      )
      .map(company => company.id);

    return clients
      .filter(
        client =>
          filteredCompanyIds &&
          client.fields.companyId &&
          filteredCompanyIds.find(
            companyId => companyId === client.fields.companyId,
          ),
      )
      .map(client => client.id);
  }, [isClient, clients, companies, options.searchKey]);

  return { filteredClientIds: companyClientIds };
};
